import { GraduationCap } from 'lucide-react';
import { LandingPageConfig } from '@/pages/LandingPageTemplate';

export const landingPageConfigs: Record<'lbsw', LandingPageConfig> = {
  lbsw: {
    examType: 'lbsw',
    path: '/lbsw',
    meta: {
      title: 'LBSW Exam Prep - Bachelor\'s Level Social Work Licensing | SWTPA',
      description: 'Prepare for your Bachelor\'s level ASWB exam with comprehensive LBSW practice tests. Get 7 free days. No card, no billing, nothing to cancel.',
    },
    hero: {
      icon: GraduationCap,
      iconBgColor: 'bg-primary-600',
      titlePrefix: 'Pass Your',
      titleGradient: 'text-primary-600',
      subtitle: 'Entry-level bachelor\'s exam prep for new social work graduates',
    },
    colors: {
      gradient: 'bg-neutral-50',
      iconBg: 'bg-primary-600',
      ctaGradient: 'bg-primary-600',
    },
    features: {
      title: 'Why Choose SWTPA for Your LBSW Exam?',
      items: [
        {
          title: 'First-Time Test Taker Friendly',
          description: 'Designed specifically for entry-level candidates taking their first licensing exam',
        },
        {
          title: '170-Question Practice Exam',
          description: 'Full-length exam matching the actual LBSW test format and difficulty',
        },
        {
          title: 'AI-Powered Adaptive Learning',
          description: 'Questions adjust to your skill level, focusing on areas that need improvement',
        },
        {
          title: 'Detailed Explanations',
          description: 'Learn from every question with comprehensive explanations and study tips',
        },
      ],
    },
    cta: {
      heading: 'Ready to Start Your LBSW Journey?',
      ctaText: 'Get 7 Free Days',
    },
    // Bachelors candidates are the ones most likely to be unsure whether their
    // board asks for the Bachelors exam at all before the first license.
    licensingNote: 'Not sure what your state requires first?',
  },
};
